import script from "./PatientNotificationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientNotificationComponent.vue?vue&type=script&setup=true&lang=js"

import "./PatientNotificationComponent.vue?vue&type=style&index=0&id=08fc92d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fc92d9"]])

export default __exports__